/*@ngInject*/
const SourceFieldDependencyController = function ($rootScope, $scope, $element, configurationConstant, currentUserModel, authorizationConstants) {

    $element.addClass('sourceFieldDependency');

    this.$onInit = function () {
        this.formFieldDependenciesMode = 'forms';

        this.isReadOnly = !currentUserModel.hasAuthorization(authorizationConstants.MANAGE_DATASETS);
    };

    $scope.$on(configurationConstant.event.SELECTOR_WIDGET_UPDATED, function (event, item1Name, item2) {
        if (_.isEmpty(item1Name) && _.isEmpty(item2)) {
            this.sourceFieldDependency.formTemplateUniqueName = '';
            this.sourceFieldDependency.fieldName = '';
        } else {
            this.sourceFieldDependency.formTemplateUniqueName = item1Name;
            this.sourceFieldDependency.fieldName = item2.fieldName;
        }

        $rootScope.$broadcast(configurationConstant.event.DATA_SET_SOURCE_FIELD_DEPENDENCY_UPDATED);
    }.bind(this));
};

angular.module('ums.configuration')
    .controller('sourceFieldDependencyController', SourceFieldDependencyController);
